import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_JOB_PROCEDURES,
  LINK_PROCEDURE_JOBS,
  UPDATE_PROCEDURE,
} from '../../../graph-queries/tar/procedure';
import { TProcedure } from '../../../lib/types';
import AspectsTable from '../AspectsTable/AspectsTable';
import ProcedureForm from '../ProcedureForm/ProcedureForm';
import classes from './JobAspects.module.scss';
import { columns } from '../../pages/Procedures/Procedures';
import { useParams } from 'react-router-dom';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobProcedure: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const { data, loading } = useQuery(GET_JOB_PROCEDURES, {
    variables: { jobId },
  });
  const [updateProcedure] = useMutation(UPDATE_PROCEDURE, {
    refetchQueries: [GET_JOB_PROCEDURES],
  });
  const [linkProcedureJobs] = useMutation(LINK_PROCEDURE_JOBS, {
    refetchQueries: [GET_JOB_PROCEDURES],
  });

  const onEditSubmit = (procedure: TProcedure) => {
    const { updatedBy, updatedAt, tarJobs, ...input } = procedure;
    return updateProcedure({ variables: { input } });
  };

  const onLinkSubmit = (selection: TProcedure[], jobIds: number[]) => {
    return Promise.all(
      selection.map((procedure) =>
        linkProcedureJobs({
          variables: {
            procedureId: procedure.procedureId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TProcedure>
      aspectName="procedure"
      data={(data?.proceduresByJobId as unknown as TProcedure[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <ProcedureForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>Procedures</div>}
    />
  );
};

export default JobProcedure;
